import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Target, BookOpen, Heart, Star } from 'lucide-react';
export function PremiumShowcaseSection() {
  const features = [{
    icon: Clock,
    title: 'Listo en 10 Segundos',
    description: 'Sin preparación. Abre el ebook y empieza.'
  }, {
    icon: Target,
    title: '30 Actividades Probadas',
    description: 'Diseñadas para captar atención sin sobreestimular.'
  }, {
    icon: BookOpen,
    title: 'Guía Paso a Paso',
    description: 'Sistema completo. Sin teoría aburrida.'
  }, {
    icon: Heart,
    title: 'Resultados Desde Día 1',
    description: 'Tu hijo pedirá las actividades.'
  }];
  const contents = ['30 Tarjetas de Actividades listas para imprimir', 'Guía de Implementación con protocolo exacto', 'Tracker de Progreso visual', 'Rutinas visuales que eliminan negociaciones', 'Protocolo de emergencia "quiero el móvil"', 'Sistema de recompensas sin pantallas'];
  return <section className="relative py-16 overflow-hidden bg-gradient-to-b from-brand-cream/30 to-white" data-id="element-449">
      <div className="absolute inset-0 opacity-[0.02]" data-id="element-450">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, #2B4C7E 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-451" />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-452">
        {/* Features grid */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-12" data-id="element-453">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white/60 backdrop-blur-sm p-5 rounded-xl border border-brand-navy/10 shadow-sm" data-id="element-454">
              <feature.icon className="w-7 h-7 text-brand-red mb-3" data-id="element-455" />
              <h3 className="font-bold text-brand-navy mb-1 text-sm" data-id="element-456">
                {feature.title}
              </h3>
              <p className="text-xs text-slate-600 leading-relaxed" data-id="element-457">
                {feature.description}
              </p>
            </motion.div>)}
        </motion.div>

        {/* What's included */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 border-2 border-brand-yellow/20 shadow-lg" data-id="element-458">
          <div className="text-center mb-6" data-id="element-459">
            <h3 className="text-2xl font-bold text-brand-navy font-serif mb-2" data-id="element-460">
              Qué Incluye Este Ebook
            </h3>
            <p className="text-sm text-slate-600" data-id="element-461">
              Tu sistema completo para tardes sin pantallas
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-3 mb-6" data-id="element-462">
            {contents.map((item, i) => <div key={i} className="flex items-start gap-2 bg-brand-cream/50 p-3 rounded-lg" data-id="element-463">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-brand-green/20 flex items-center justify-center mt-0.5" data-id="element-464">
                  <svg className="w-3 h-3 text-brand-green" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-465">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-466" />
                  </svg>
                </div>
                <span className="text-sm text-brand-navy leading-relaxed" data-id="element-467">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="pt-6 border-t border-brand-navy/10 text-center" data-id="element-468">
            <div className="flex items-center justify-center gap-1 mb-2" data-id="element-469">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-yellow text-brand-yellow" data-id="element-470" />)}
              <span className="ml-2 text-sm font-semibold text-brand-navy" data-id="element-471">
                Valorado por 500+ familias
              </span>
            </div>
            <p className="text-xs text-brand-navy/60" data-id="element-472">
              Formato PDF • Descarga inmediata • Acceso de por vida
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}